import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';

import { ErrorBoundary } from './components/ErrorBoundary';
import { KeycloakApp } from './components/KeycloakApp';
import configs from './configs';
import { NotificationProvider } from './contexts/NotificationContext';

function App() {
  const keycloak = new Keycloak({
    url: configs.base.KEYCLOAK_URL,
    realm: configs.base.KEYCLOAK_REALM,
    clientId: configs.base.KEYCLOAK_CLIENT_ID,
  });

  return (
    <ErrorBoundary>
      <NotificationProvider>
        <ReactKeycloakProvider
          authClient={keycloak}
          initOptions={{
            onLoad: 'check-sso', // Always use check-sso, let KeycloakApp handle the logic
            pkceMethod: 'S256',
            checkLoginIframe: false, // Disable iframe check to avoid issues
            enableLogging: true,
            redirectUri: window.location.href, // Keep current URL instead of redirecting to root
            checkLoginIframeInterval: 2000, // Check every 2 seconds
            responseMode: 'fragment', // Use fragment mode for better compatibility
            flow: 'standard', // Use standard flow for better compatibility
          }}
          onEvent={(event, error) => {
            console.log('🔍 Keycloak Event:', event, error);
            if (event === 'onAuthError') {
              console.error('❌ Keycloak Authentication Error:', error);
              // Handle specific error cases
              if (error?.error === 'login_required') {
                console.log('🔄 Login required, will redirect to login...');
                // Don't clear tokens for login_required, just redirect
              } else if (error?.error === 'invalid_grant') {
                console.log('🔄 Invalid grant, clearing tokens and retrying...');
                // Clear any stored tokens
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                localStorage.removeItem('id_token');
              } else if (error?.error === 'access_denied') {
                console.log('🔄 Access denied, clearing tokens...');
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                localStorage.removeItem('id_token');
              }
            } else if (event === 'onReady') {
              console.log('✅ Keycloak is ready');
            } else if (event === 'onInitError') {
              console.error('❌ Keycloak initialization error:', error);
            }
          }}
          onTokens={(tokens) => {
            console.log('🔍 Keycloak Tokens:', tokens);
          }}
        >
          <KeycloakApp />
        </ReactKeycloakProvider>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;
